import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { onInstallAvailable, promptInstall, isStandalone } from "../pwa";

// Subtle "Install app" button shown only when the browser offers installation.
export default function InstallAppButton({ className = "", label = "Install app", style }) {
  const [available, setAvailable] = useState(false);

  useEffect(() => onInstallAvailable(setAvailable), []);

  if (!available || isStandalone()) return null;

  return (
    <button
      type="button"
      data-testid="install-app-btn"
      onClick={() => promptInstall()}
      style={style}
      className={className || "inline-flex items-center gap-2 rounded-full border border-current px-4 py-2 text-sm font-medium transition-opacity hover:opacity-80"}
    >
      <Download size={15} /> {label}
    </button>
  );
}
